var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`md-layout-item md-size-${_vm.size} md-small-size-${_vm.size*2} md-xsmall-size-50`},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('p',{class:_vm.copy ? 'copy-text' : '',on:{"click":function($event){_vm.copy ? _vm.copyText(_vm.value) : ''}}},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/RoadSinisters/File/FField.vue